import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './AuditLogEventFormatter.less';

class AuditLogEventTypeFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    const labelValue = utils.TranslateUtils.translate(value, intl);
    return (
      <div className={styles.dlAuditLogEventTitle} title={labelValue}>
        {labelValue}
      </div>
    );
  }
}

AuditLogEventTypeFormatter.displayName = 'AuditLogEventTypeFormatter';

AuditLogEventTypeFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.string,
};

AuditLogEventTypeFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(AuditLogEventTypeFormatter);
